'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const{IncidentTooltipDirectiveController}=require('./incidentTooltipDirective');

const alignmentOptions={
anchorToTargetSide:'top',
alignFromTooltipSide:'bottom'};let


FleetIncidentTooltipDirective=class FleetIncidentTooltipDirective extends BaseControllerBackedDirective{
get objectBindings(){
return[
'person',
'fatigueThresholdStatus',
'deviationThresholdStatus',
'deviation',
'fatigue',
'time',
'description',
'timezone',
'targetElement',
'isActive',
'incident'];

}

get templateUrl(){
return'/templates/directives/tooltips/incidentTooltip/incidentTooltipTemplate';
}

get controller(){
return FleetIncidentTooltipDirectiveController;
}};let


FleetIncidentTooltipDirectiveController=class FleetIncidentTooltipDirectiveController extends IncidentTooltipDirectiveController{
static get $inject(){
return['timeFormattingService','$element','$timeout','tooltipService','elementService'];
}

constructor(timeFormattingService,$element,$timeout,tooltipService,elementService){
super(timeFormattingService);

tooltipService.updateTooltipPosition(alignmentOptions,this.targetElement,$element.parent());
$timeout(()=>{
if(!this.isActive){
return;
}

elementService.addClass($element,'open');
},100);
}};


module.exports=FleetIncidentTooltipDirective;
//# sourceMappingURL=fleetIncidentTooltipDirective.js.map
